import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

const footerLinks = {
  Categories: [
    { label: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { label: 'Hoodies & Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
    { label: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
    { label: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  ],
  Resources: [
    { label: 'Complete Guide', url: '/article/itaobuyspreadsheet-complete-guide', internal: true },
    { label: 'How It Works', url: '/#how-it-works', internal: true },
    { label: 'FAQ', url: '/#faq', internal: true },
    { label: 'All Categories', url: '/#categories', internal: true },
  ],
  'Quick Links': [
    { label: 'itaobuy sheet', url: mainSiteUrl },
    { label: 'Buy It Now', url: mainSiteUrl },
    { label: 'View Spreadsheet', url: mainSiteUrl },
    { label: 'Product Comparison', url: mainSiteUrl },
  ],
  Safety: [
    { label: 'Verified Suppliers', url: '/#about', internal: true },
    { label: 'How We Verify', url: '/#how-it-works', internal: true },
    { label: 'Sourcing Tips', url: '/article/itaobuyspreadsheet-complete-guide', internal: true },
    { label: 'Contact', url: mainSiteUrl },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide uppercase">
                {title}
              </h4>
              <div className="w-8 h-px bg-accent-500/60 mb-4"></div>
              <ul className="space-y-2.5">
                {links.map((link) =>
                  link.internal ? (
                    <li key={link.label}>
                      <Link
                        to={link.url}
                        className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 md:mt-20 pt-8 border-t border-foreground-800/30 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <p className="text-5xl md:text-6xl font-heading font-bold text-background-50 tracking-tight leading-none">
              itaobuy
            </p>
            <p className="text-5xl md:text-6xl font-heading font-bold text-accent-500 tracking-tight leading-none mt-1">
              spreadsheet
            </p>
            <div className="w-12 h-px bg-background-600 mt-4"></div>
            <p className="text-xs text-foreground-400 mt-3 max-w-xs">
              Your trusted source for structured China product sourcing data. Compare verified suppliers and make smarter buying decisions.
            </p>
          </div>

          <div className="flex flex-col items-start sm:items-end gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 itaobuy.my — All rights reserved.
            </p>
            <div className="flex items-center gap-3">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/30 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="Main site">
                <i className="ri-external-link-line text-sm"></i>
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/30 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="Spreadsheet">
                <i className="ri-file-excel-2-line text-sm"></i>
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/30 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="Shopping">
                <i className="ri-shopping-bag-3-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}